<script setup lang="ts">
import { useI18n } from 'vue-i18n';

defineProps<{
  icon?: string;
  title?: string;
  message?: string;
  // Set when `message` is dynamic, backend-driven content that GlobalSEO should translate
  // (e.g. a warehouse-configured error message), instead of the app's own static copy.
  translateMessage?: boolean;
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="pa-4 d-flex flex-column justify-space-around align-center text-center fill-height wrapper">
    <div>
      <v-icon size="100px" class="juno-i18n-exclude">{{ icon || 'mdi-alert-circle' }}</v-icon>
      <p class="title typography-heading-lg-bold juno-i18n-exclude">
        {{ title || t('errorScreen.defaultTitle') }}
      </p>
      <p class="typography-body-md" :class="{ 'juno-i18n-exclude': !translateMessage }">
        {{ message || t('errorScreen.defaultMessage') }}
      </p>
    </div>
  </div>
</template>

<style scoped>
.wrapper {
  color: #1e3036;
}

.title {
  margin-top: 28px;
  margin-bottom: 20px;
}
</style>
